import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Who do you typically work with?",
    a: "Motels, hotels, hostels, Airbnb operators, investment property owners, holiday home managers and boutique accommodation operators across the Bay of Plenty and New Zealand. If a property sleeps paying guests — from a single short-stay rental through to a multi-site hotel group — the playbook applies.",
  },
  {
    q: "How is this different from an Airbnb coach?",
    a: "Most coaches in this space teach theory without having run an accommodation business at scale. Black Rock Hospitality is led by an operator with genuine, hands-on hospitality management experience — across resorts, hotels and multi-site portfolios in New Zealand and Australia. We're happy to coach, guide and mentor where that's what's required; but our real value sits in working alongside you across pricing, distribution, operations and team — applying lessons learned from inside the industry to deliver measurable, real-world outcomes.",
  },
  {
    q: "What does the mini audit actually include?",
    a: "A 30-minute discovery call plus a written email back identifying specific revenue or efficiency opportunities we see in your operation. No obligation, no sales pitch.",
  },
  {
    q: "How quickly do you see results?",
    a: "Pricing changes typically show up in bookings within weeks. Operational efficiency (housekeeping, comms, SOPs) usually compounds over a few months. The audit deliverable comes with a written 90-day plan so you can see the sequence.",
  },
  {
    q: "Do you work remotely or on site?",
    a: "Both — though we prefer to meet in person where possible. It helps us get the best understanding of your property, your people and the culture you're trying to build. That said, we can operate fully remotely, and we'll work with you to land on the method that delivers the best possible outcome for your business.",
  },
  {
    q: "What if my numbers aren't broken?",
    a: "Honest answer: many operators we speak with have meaningful upside simply because no one is actively managing it. If we don't find clear opportunities in the audit, we'll tell you and refund the difference.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-36 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-[#C2A878]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#C2A878] font-semibold">
              Questions
            </span>
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white tracking-tight">
            Frequently <em className="text-[#C2A878] not-italic">asked.</em>
          </h2>
        </div>

        <div className="lg:col-span-8">
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="border-t border-white/10"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10 px-0"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-lg md:text-xl font-serif text-white hover:text-[#C2A878] hover:no-underline py-7"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 leading-relaxed text-base pb-7 max-w-3xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
